import React from 'react';
import HomePageFooter from 'components/MarketingPageFooter';
import { Link } from 'react-router';
import { Helmet } from 'react-helmet';

import { routes } from 'config/routes';

const mainContainerStyles = `.main{padding-top:0; margin-top:0;}`;

const NotFound = () => {
  return (
    <div className="not-found-wrapper">
      <Helmet>
        <style>
          {mainContainerStyles}
        </style>
      </Helmet>
      <section className="container container-info">
        <div className="row not-found-container">
          <div className="not-found-message">
            <h3>Darn!</h3>
            <p className="not-found-text">
              {`We couldn\'t find the page you were looking for. `}
              Maybe our
              <Link to={routes.FAQ} className="faq-link">FAQ</Link>
              or
              <Link to={routes.MAIN} className="faq-link">homepage</Link>
              can help?
            </p>
            <Link
              to={routes.MAIN}
              className="main-link"
            >
              Go Back
            </Link>
          </div>
          <figure className="not-found-illustration">
            <picture>
              <source
                srcSet="https://adstudio.scdn.co/assets/landingpage/404_Illustration.svg"
                media="(max-width: 768px)"
              />
              <img
                src="https://adstudio.scdn.co/assets/landingpage/404_Illustration.svg"
                alt="404 Error Art Work"
                className="center-block"
              />
            </picture>
          </figure>
        </div>
      </section>

      <HomePageFooter />
    </div>
  );
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js